import { useEffect } from 'react'
//Redux:
import { useGetOrganizationsQuery } from '../../../../services/organizationsApi';
import { setOrganizations } from '../../../../redux/slices/organizationsSlice';
//Hooks:
import { useAppDispatch } from '../../../../hooks/reduxHooks';
import { filterOrganizations } from '../../../../utils/functions';

const useOrganizationSelector = () => {
    const dispatch = useAppDispatch();
    const { data, isFetching, error } = useGetOrganizationsQuery({});

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const filteredOrganizations = filterOrganizations(data);
            dispatch(setOrganizations(filteredOrganizations));
        }
    }, [data]);

    return {
        organizations: data ? filterOrganizations(data) : [],
        isFetching,
        error
    }
}

export default useOrganizationSelector